import React from 'react'
import { inject, observer } from 'mobx-react'
import { compose, lifecycle, withProps } from 'recompose'
import Tools from './tools/Tools'
import MapContainer from './map/MapContainer'
import ErrorBar from './ErrorBar'
import PrintContainer from './PrintContainer'
import StatusMessage from './StatusMessage'
import Icons from 'components/common/Icons'
import Tour from './Tour'
import Tooltips from './Tooltips'
import _ from 'lodash'
import classnames from 'classnames'
import { DOCUMENT_EVENTS } from '../constants'
import DataUpdateInfoModal from './DataUpdateInfoModal'
import PointOfInterest from './pointOfInterest/PointOfInterest'
import SuccessErrorModal from './common/SucessErrorModal'
import UpgradeToProCard from './common/UpgradeToProCard'

const contents = (loading, focusedInteraction, isGlobalLoaderActive, uiStore) => loading
  ? <div className='inner loading' />
  : (
    <div
      className={classnames({
        inner: true,
        'focused-interaction': focusedInteraction
      })}
    >
      <DataUpdateInfoModal />
      <Tour />
      <MapContainer />
      <Tools />
      <PointOfInterest />
      <Tooltips />
      {(isGlobalLoaderActive || (uiStore && uiStore.isPoiSaving)) && (
      <div className='loader-overlay' aria-live='polite'>
        <div className='spinner' />
      </div>
      )}
      <ErrorBar />
      <PrintContainer />
    </div>
    )

const enhance = compose(
  withProps(props => ({
    contents: contents(
      props.uiStore.loading,
      props.selectionStore.focusedInteraction,
      props.uiStore.isGlobalLoaderActive,
      props.uiStore
    )
  })),
  lifecycle({
    componentDidMount () {
      window.addEventListener('resize', () => {
        this.props.uiStore.windowSize = {
          width: window.innerWidth,
          height: window.innerHeight
        }
      }, true)

      // Allow the selection to respond to document-level events
      _.map(DOCUMENT_EVENTS, (documentName, name) => {
        document.addEventListener(name, e => {
          if (this.props.selectionStore) {
            this.props.selectionStore.passEvent(documentName, e)
          }
        }, true)
      })
      this.props.uiStore.initializeUser()
    }
  })
)

const Container = ({ contents, uiStore }) => {
  return (
    <div className='container'>
      <Icons />
      {contents}
      <UpgradeToProCard />
      <SuccessErrorModal uiStore={uiStore} />
      <StatusMessage />
    </div>
  )
}

export default inject('uiStore', 'selectionStore')(
  observer(enhance(Container))
)
